import React from "react";
import "./Broadcast.scss";
import { MediaComponent } from "../MediaComponent/MediaComponent";
export const Broadcast = (props) => {
    return (React.createElement("div", { className: "Broadcast" },
        React.createElement(MediaComponent, { media: props.broadcast.media, objectFit: props.broadcast.objectFit, duration: props.broadcast.media.type === "synapi" ? props.broadcast.duration : undefined, items: props.broadcast.items })));
};
